export function getConversationID(accountA, accountB) {
    accountA = accountA.toLowerCase();
    accountB = accountB.toLowerCase();
    if (accountA > accountB) {
        return `${accountA}${accountB}`;
    }
    else {
        return `${accountB}${accountA}`;
    }
}
export function publicKeyAuthorizationMessage({ address, publicKey }) {
    return `I authorize the following Public Key to represent me:\n ${publicKey}\n\n  Others can use this key to write me messages`;
}
//# sourceMappingURL=index.js.map